module.exports = __webpack_public_path__ + "img/mrp-logo.3aeddbb1.png";